import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Wrench } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/app");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-4 py-12 bg-background">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <span className="h-10 w-10 rounded-xl bg-blue-600 text-white grid place-items-center">
            <Wrench className="h-5 w-5" />
          </span>
          <span className="font-display font-bold text-xl text-slate-900">Mon Entretien Auto</span>
        </Link>
        <div className="bg-white border border-slate-200 rounded-xl p-7 shadow-sm animate-fade-up">
          <h1 className="font-display text-2xl font-bold text-slate-900">Connexion</h1>
          <p className="mt-1 text-sm text-slate-500">Accédez à votre carnet d'entretien.</p>
          <form onSubmit={submit} className="mt-7 space-y-5" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} data-testid="login-email-input"
                onChange={(e) => setEmail(e.target.value)} placeholder="vous@exemple.fr" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Mot de passe</Label>
              <PasswordInput id="password" required value={password} testId="login-password-input"
                onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            {error && (
              <p data-testid="login-error" className="text-sm font-medium text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                {error}
              </p>
            )}
            <Button type="submit" disabled={loading} data-testid="login-submit-btn"
              className="w-full rounded-full bg-blue-600 hover:bg-blue-700">
              {loading ? "Connexion…" : "Se connecter"}
            </Button>
          </form>
          <p className="mt-6 text-sm text-slate-500 text-center">
            Pas encore de compte ?{" "}
            <Link to="/inscription" data-testid="go-register-link" className="font-semibold text-blue-600 hover:text-blue-700">
              Créer un compte
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
